import './pokemon.module.css';
import { Provider } from 'react-redux';
import PokemonComponent from './pokemon';
import { pokeStore } from './reducers/store';

function PokeApp() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    return (
        <div className="PokeApp">
            <Provider store={pokeStore} >
                <PokemonComponent />
            </Provider>
        </div>
    );
}

export default PokeApp;